export default "__VITE_ASSET__COh063SZ__"